import { EnvironmentProviders } from "@angular/core";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getMessaging, provideMessaging } from "@angular/fire/messaging";
import { environment } from "@environments/environment";

/**
 * Provides Firebase configuration and services
 * @returns Environment providers for Firebase functionality
 */
export function provideFirebase(): EnvironmentProviders[] {
  return [provideFirebaseApp(() => initializeApp(environment.firebase)), provideMessaging(() => getMessaging())];
}

/**
 * 
    // AngularFire compatibility API (for components that depend on it)
    makeEnvironmentProviders([
      importProvidersFrom(AngularFireModule.initializeApp(environment.firebase), AngularFireMessagingModule),
      {
        provide: VAPID_KEY,
        useValue: environment.VAPIDKEY,
      },
      {
        provide: SERVICE_WORKER,
        useFactory: () =>
          (typeof navigator !== "undefined" && navigator.serviceWorker?.register("firebase-messaging-sw.js", { scope: "__" })) || undefined,
      },
    ]),

 */
